import {IModularHousesPublicOffer} from "@pg-mono/rp-api-routes";

export function getConstructionPermitText(buildingPermitRequired: IModularHousesPublicOffer["building_permit_required"]) {
    if (buildingPermitRequired) {
        return "Potrzebne zezwolenie na budowę";
    }

    return "Bez zezwolenia";
}
import {IModularHousesPublicOffer} from "@pg-mono/rp-api-routes";

export function getConstructionPermitText(buildingPermitRequired: IModularHousesPublicOffer["building_permit_required"]) {
    if (buildingPermitRequired) {
        return "Potrzebne zezwolenie na budowę";
    }

    return "Bez zezwolenia";
}
